import { Component, Inject, OnInit } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { Subscription } from 'rxjs'

import { TranslateService } from '@ngx-translate/core'
import { SiteService } from '../../../services/site.service'
import { MessageService } from '../../../services/message.service'
import { LeaseTransferSummary } from '../../../models/leaseTransferSummary'
import { ILeaseTransferSummary } from '../../../types/leaseTransferSummary'

interface ModalData {
	referenceNumber: string
	leaseTransferSummary: ILeaseTransferSummary
  }

@Component({
    selector: 'app-request-summary-lease-transfer-modal',
    templateUrl: './request-summary-lease-transfer-modal.component.html',
    styleUrls: ['./request-summary-lease-transfer-modal.component.scss'],
    standalone: false
})
export class RequestSummaryLeaseTransferModalComponent implements OnInit 
{
	loginSessionExpiredSubscription: Subscription

	referenceNumber: string = ''
	summary = new LeaseTransferSummary()

	constructor(
		public dialogRef: MatDialogRef<RequestSummaryLeaseTransferModalComponent>, @Inject(MAT_DIALOG_DATA) public data: ModalData,
		private siteService: SiteService,
		private translateService: TranslateService,
		private messageService: MessageService
	) 
	{
		this.loginSessionExpiredSubscription = this.messageService.loginSessionExpired$.subscribe(() =>
		{
			this.closeModal()
		})
	}

	ngOnInit() 
	{
		if (this.data.referenceNumber && this.data.leaseTransferSummary)
		{
			this.referenceNumber = this.data.referenceNumber

			this.summary.customerName = this.data.leaseTransferSummary.customerName
			this.summary.leaseNumber = this.data.leaseTransferSummary.leaseNumber
			this.summary.dealerName = this.data.leaseTransferSummary.dealerName
			this.summary.dealerAddress = this.data.leaseTransferSummary.dealerAddress
			this.summary.dealerPhone = this.data.leaseTransferSummary.dealerPhone
		}
	}

	closeModal(): void
	{
		this.dialogRef.close(false)
	}

	logout()
	{
		this.dialogRef.close(false)
	}

	extendSession()
	{
		this.dialogRef.close(true)
	}

	print(): void
	{
		this.siteService.printHtmlElement('printSummarySectionId', this.translateService.instant('REQUEST_SUMMARY_HEADING'))
	}
}
